import {createApp} from 'vue'
import App from './App.vue'
import "leaflet/dist/leaflet.css"

createApp(App).mount('#app')
